var _path;
import * as React from "react";
function SvgAngleLightUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.982 19.198l13.403 13.61a1.388 1.388 0 010 1.964l-.82.82a1.388 1.388 0 01-1.965 0L20 23.774 8.4 35.581a1.388 1.388 0 01-1.964 0l-.82-.82a1.388 1.388 0 010-1.964l13.402-13.61a1.398 1.398 0 011.964.01zm-1.964-14.79L5.615 18.02a1.388 1.388 0 000 1.964l.82.82a1.388 1.388 0 001.965 0L20 8.984l11.6 11.809a1.388 1.388 0 001.964 0l.82-.82a1.388 1.388 0 000-1.964L20.983 4.398a1.398 1.398 0 00-1.964.01z"
  })));
}
export default SvgAngleLightUp;